import { render, staticRenderFns } from "./CourseRequestForms.vue?vue&type=template&id=09850792&"
import script from "./CourseRequestForms.vue?vue&type=script&lang=js&"
export * from "./CourseRequestForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09850792')) {
      api.createRecord('09850792', component.options)
    } else {
      api.reload('09850792', component.options)
    }
    module.hot.accept("./CourseRequestForms.vue?vue&type=template&id=09850792&", function () {
      api.rerender('09850792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CourseRequestForms.vue"
export default component.exports